/* Geiss Product Page — Image Carousel Component
   Auto-Advance mit User-Pause + a11y-konform (prefers-reduced-motion). */
if (!customElements.get('product-image-carousel')) {
  customElements.define('product-image-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.track');
      if (!this.track) return;
      this.dots = Array.from(this.querySelectorAll('.dot'));
      this.toggleBtn = this.querySelector('.carousel-toggle');
      this.intervalMs = parseInt(this.dataset.interval || '0', 10);
      this.userWantsPlay = false;
      this.timer = null;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.userPause();
          this.goTo(i);
        });
      });
      this.track.addEventListener('scroll', () => this.updateActive(), { passive: true });
      this.track.addEventListener('touchstart', () => this.userPause(), { passive: true });
      this.track.addEventListener('mousedown', () => this.userPause());

      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', () => this.toggle());
      }

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.intervalMs > 0 && this.dots.length > 1 && !reduceMotion) {
        this.play();
      } else {
        this.updateButton();
      }
    }

    disconnectedCallback() {
      this.clearTimer();
    }

    play() {
      this.clearTimer();
      this.userWantsPlay = true;
      this.timer = setInterval(() => this.next(), this.intervalMs);
      this.updateButton();
    }

    userPause() {
      this.clearTimer();
      this.userWantsPlay = false;
      this.updateButton();
    }

    toggle() {
      if (this.userWantsPlay) {
        this.userPause();
      } else if (this.intervalMs > 0) {
        this.play();
      }
    }

    clearTimer() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    next() {
      const total = this.track.children.length;
      if (!total) return;
      const w = this.track.clientWidth;
      if (!w) return;
      const current = Math.round(this.track.scrollLeft / w);
      this.goTo((current + 1) % total);
    }

    goTo(i) {
      const slide = this.track.children[i];
      if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    updateActive() {
      const w = this.track.clientWidth;
      if (!w) return;
      const active = Math.round(this.track.scrollLeft / w);
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === active));
    }

    updateButton() {
      if (!this.toggleBtn) return;
      this.toggleBtn.dataset.state = this.userWantsPlay ? 'playing' : 'paused';
      this.toggleBtn.setAttribute('aria-label', this.userWantsPlay ? 'Bilderwechsel pausieren' : 'Bilderwechsel starten');
    }
  });
}

/* Geiss Produktseite — Zurück-Link (sessionStorage/Referrer) + Sprunglink zu Produktdetails.
   Zuvor inline in geiss-back-link.liquid bzw. geiss-jump-to-details.liquid, hier konsolidiert. */
(function () {
  var link = document.querySelector('[data-back-link]');
  if (!link || link.getAttribute('data-from-liquid') === 'true') return;
  try {
    var url = sessionStorage.getItem('geiss:lastCollectionUrl');
    var title = sessionStorage.getItem('geiss:lastCollectionTitle');
    if (!url && document.referrer) {
      var ref = new URL(document.referrer, window.location.origin);
      if (ref.host === window.location.host) {
        var m = ref.pathname.match(/^\/collections\/[^\/]+$/);
        if (m) { url = ref.pathname; }
      }
    }
    if (url) {
      link.setAttribute('href', url);
      if (title) {
        var label = link.querySelector('[data-back-label]');
        if (label) label.textContent = title;
      }
    }
  } catch (e) {}
})();

(function () {
  var jump = document.querySelector('[data-jump-details]');
  if (!jump) return;
  jump.addEventListener('click', function (e) {
    var target = document.querySelector('.shopify-section--produktdetails');
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    var focusTarget = target.querySelector('.produktdetails__heading') || target;
    focusTarget.setAttribute('tabindex', '-1');
    focusTarget.focus({ preventScroll: true });
  });
})();

/* Geiss — Versand-Infozeile: scrollt zum Versand-Akkordeon (#pd-versand) und
   öffnet es, statt zur Versandseite wegzunavigieren. */
(function () {
  var trigger = document.querySelector('[data-jump-versand]');
  if (!trigger) return;
  trigger.addEventListener('click', function (e) {
    var target = document.getElementById('pd-versand');
    if (!target) return;
    e.preventDefault();
    if (target.tagName === 'DETAILS') { target.open = true; }
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    var sum = target.querySelector('summary');
    if (sum) { sum.setAttribute('tabindex', '-1'); sum.focus({ preventScroll: true }); }
  });
})();